<template>
  <v-select
    v-model="internalValue"
    :items="items"
    :label="label || 'Industria'"
    placeholder="Seleccione Industria"
    item-value="id"
    item-text="name"
    outlined
    dense
    :error-messages="errors"
    :disabled="disabled"
    @input="updateValue"
    @change="change"
    hide-details="auto"
  ></v-select>
</template>

<script>
export default {
  name: 'IndustrySelection',
  props: {
    value: [String, Number, Object],
    errors: {
      type: [Array, String],
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filtro: {
      type: Boolean,
      default: true
    },
    label: String
  },
  data: () => ({
    items: [],
    internalValue: null
  }),
  watch: {
    value: {
      handler(newVal) {
        this.internalValue = (newVal && typeof newVal === 'object') ? newVal.id : newVal
      },
      immediate: true
    }
  },
  methods: {
    updateValue(val) {
      this.$emit('input', val)
    },
    change(val) {
      this.$emit('change', val)
    }
  },
  mounted() {
    const storeIndustries = this.$store.state.industries || []
    if (this.filtro) {
      this.items = [{ name: 'Todas las industrias', id: '' }, ...storeIndustries]
    } else {
      this.items = storeIndustries
    }
  }
}
</script>